"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminFeatureFlagsWatchers = exports.adminFeatureFlagsReducers = void 0;
const add_1 = require("./add.js");
const redux_1 = require("redux");
const get_1 = require("./get.js");
const remove_1 = require("./remove.js");
const update_1 = require("./update.js");
const _id_1 = require("./_id/index.js");
const xuder_1 = require("@sonar-software/xuder");
exports.adminFeatureFlagsReducers = (0, redux_1.combineReducers)({
    byId: _id_1.adminFeatureFlagByIdReducers,
    get: (0, xuder_1.joinReducers)([
        add_1.addAdminFeatureFlagCustomerSlice.syncReducer,
        get_1.getAdminFeatureFlagsSlice.asyncReducers,
        remove_1.removeAdminFeatureFlagCustomerSlice.syncReducer,
        update_1.updateAdminFeatureFlagSlice.syncReducer
    ], get_1.getAdminFeatureFlagsSlice.asyncState)
});
exports.adminFeatureFlagsWatchers = (0, xuder_1.combineAllWatchers)([
    _id_1.adminFeatureFlagByIdWatchers,
    get_1.getAdminFeatureFlagsSlice.asyncWatchers
]);
//# sourceMappingURL=index.js.map